import React from "react";

const LoadingIndicatorComponent = () => (
  <div style={{
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '40px 0',
    minHeight: '200px'
  }}>
    <div style={{
      fontSize: '32px',
      fontFamily: 'var(--title-font)',
      color: 'var(--background-bg-dark)',
      textAlign: 'center'
    }}>
      Loading...
    </div>
  </div>
);

export default LoadingIndicatorComponent;